// extracted by mini-css-extract-plugin
var _1 = "list__Ze1oI";
var _2 = "list-item___MnPN";
var _3 = "section-title__UAwoe";
export { _1 as "list", _2 as "listItem", _3 as "sectionTitle" }
